import React, { FC } from "react";
import { cn } from "@/lib/utils";

interface MetricItem {
  label: string;
  value: string | number;
  secondary: string;
  valueClassName?: string;
  secondaryClassName?: string;
}

interface Props {
  className?: string;
  items: MetricItem[];
}

export const DashboardKeyMetrics: FC<Props> = ({ className, items }) => {
  return (
    <div
      className={cn(
        "flex min-h-0 flex-1 flex-col gap-3 overflow-visible",
        className,
      )}
    >
      {items.map((item) => (
        <div key={item.label} className="flex flex-col gap-0.5">
          <span className="text-xs font-normal leading-normal text-monochrome-core-2">
            {item.label}
          </span>
          <div className="flex items-baseline gap-1.5">
            <span
              className={cn(
                "text-sm font-semibold leading-normal text-monochrome-core-2/75",
                item.valueClassName,
              )}
            >
              {item.value}
            </span>
            <span
              className={cn(
                "text-sm font-medium leading-normal text-eathy-comfort-2",
                item.secondaryClassName,
              )}
            >
              {item.secondary}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
